import { render, staticRenderFns } from "./DadosAreaMonitorada.vue?vue&type=template&id=44a02ef2&scoped=true&lang=pug"
import script from "./DadosAreaMonitorada.vue?vue&type=script&lang=js"
export * from "./DadosAreaMonitorada.vue?vue&type=script&lang=js"
import style0 from "./DadosAreaMonitorada.vue?vue&type=style&index=0&id=44a02ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a02ef2",
  null
  
)

export default component.exports